import React, { useEffect, useState } from 'react'
import SectionWrapper from '../../../components/pageComponents/SectionWrapper'
import { Button, Col, Row } from 'antd'
import CourseCard from '../../../components/cards/CourseCard'
import axios from 'axios'
import { courseEnrollmentsOfUserUrl, courseUrl } from '../../../urls'
import { useDispatch, useSelector } from 'react-redux'
import { __hideLoader, __showLoader } from '../../../Redux Store/Slices/loader'
import useCustomNotification from '../../../hooks/useCustomNotification'
import useErrorHandler from '../../../hooks/useErrorHandler'
import { OfferingCourseCard } from '../../Home/CourseOfferings'

const Courses = () => {
    const [sellingCourses, setSellingCourses] = useState([]);
    const { openNotification, contextHolder } = useCustomNotification()
    const dispatch = useDispatch();
    const handleError = useErrorHandler();
    const user = useSelector(state => state.auth.user);


    useEffect(() => {
        dispatch(__showLoader("Getting Courses"))

        axios.get(courseUrl).then(res => {
            setSellingCourses(res.data);
        }).catch(err => {
            handleError(err)
        }).finally(() => {
            dispatch(__hideLoader())
        })
    }, []);

    return (
        <div className="flex flex-col gap-12">
            {contextHolder}
            {/* <CoursesSection
                title={"Purchased Courses"}
                courses={courses}
                isEnrollModal
                seeCertificate
                isViewCard
            /> */}
            <CoursesSection title={"Courses For You"} courses={sellingCourses} />
        </div>
    )
}

export default Courses;
export const CoursesSection = ({ title, rightComp, courses = [], setEnrollModalFalse, isEnrollModal, isViewCard = false }) => {
    return (
        <SectionWrapper title={title} rightComp={rightComp}>
            <Row gutter={[16, 16]}>
                {!courses.length ? (
                    <p>Courses Not Purchased</p>
                ) : (
                    courses.map((course, index) => (
                        <Col xs={24} sm={12} md={12} key={index}>
                            <OfferingCourseCard
                                className="md:w-full"
                                isEnrollDirect
                                course={course?.course || course}
                                setEnrollModalFalse={setEnrollModalFalse}
                                seeCertificate
                                isEnrollModal={isEnrollModal}
                                type={course.type}
                            />
                        </Col>
                    ))
                )}
            </Row>
        </SectionWrapper>
    );
};
